import { SHIconLoading } from "@components/design-systems";
import { DuplicateSVG } from "@components/svgs";
import { DELAY_TIME } from "@constants";
import { IconButton, Tooltip, tooltipClasses, useTheme } from "@mui/material";
export interface DuplicateButtonProps {
  width?: string;
  height?: string;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  isLoading?: boolean;
  disabled?: boolean;
  tooltipTitle?: string;
  [key: string]: any;
}
export const DuplicateButton = ({
  width = "30px",
  height = "30px",
  isLoading = false,
  disabled = false,
  tooltipTitle,
  ...others
}: any) => {
  const { shadows, palette } = useTheme();
  return (
    <Tooltip
      title={tooltipTitle}
      enterDelay={DELAY_TIME}
      enterNextDelay={DELAY_TIME}
      slotProps={{
        popper: {
          sx: {
            [`&.${tooltipClasses.popper}[data-popper-placement*="bottom"] .${tooltipClasses.tooltip}`]:
              {
                marginTop: '3px',
              },
          },
        },
      }}
    >
      <IconButton
        {...others}
        disableRipple
        disabled={disabled}
        sx={{
          width,
          height,
          p: 0,
          borderStyle: "solid",
          borderWidth: "1px",
          backgroundColor: palette.common.white,
          borderColor: palette.common.black,
          boxShadow: shadows[1],
          "&:hover": {
            borderColor: palette.primary[800],
            boxShadow: "none",
          },
          "&:active": {
            backgroundColor: palette.primary.dark,
            borderColor: palette.common.black,
            boxShadow: `inset 0 4px 4px ${palette.primary[900]}`,
            "&>svg>path": {
              fill: palette.common.white,
            },
          },
          "&:disabled": {
            border: `1px solid ${palette.text.disabled}`,
            backgroundColor: palette.common.white,
            "&>svg>path": {
              fill: palette.text.disabled,
            },
          },
        }}
      >
        {isLoading ? <SHIconLoading size={15} /> : <DuplicateSVG />}
      </IconButton>
    </Tooltip>
  );
};
